import { render, staticRenderFns } from "./coach-feedback.vue?vue&type=template&id=09466bac&scoped=true"
import script from "./coach-feedback.vue?vue&type=script&lang=js"
export * from "./coach-feedback.vue?vue&type=script&lang=js"
import style0 from "./coach-feedback.vue?vue&type=style&index=0&id=09466bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09466bac",
  null
  
)

export default component.exports